import React from 'react'
import ProjData from '../projects/data.json'
import ReactMarkdown from 'react-markdown'
import { Container, Grid, Image, Responsive, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { findNextProjectId, findPreviousProjectId } from '../projects/ProjectsUtils'

const generateTextBlock = (title, text) => (
  <div>
    <div className={'projectTextBlock'}>
      <h2>{title}</h2>
    </div>
    <div className={'projectInfo'}><ReactMarkdown source={text}/></div>
  </div>
)

const generateContent = (match) => {
  const idNum = match.params.idNum
  const projects = ProjData.projects
  const project = projects.find((p) => (String(p.idNum) === idNum))
  let title = ''
  let image01 = null
  let image02 = null
  let image03 = null
  const textBlocks = [];
  if (project !== undefined) {
    title = project.title
    if (project.images && project.images.length > 0) {
      let imageSrc01 = '/assets/' + project.images[0].src
      image01 = <Image src={imageSrc01}/>
    }
    if (project.images && project.images.length > 1) {
      let imageSrc02 = '/assets/' + project.images[1].src
      image02 = <Image src={imageSrc02}/>
    }
    if (project.images && project.images.length > 2) {
      let imageSrc03 = '/assets/' + project.images[2].src
      image03 = <Image src={imageSrc03}/>
    }
    if (project.text) {
      for(let i=0;i<project.text.length;i++){
        let subTitle = project.text[i].title;
        let copyText = project.text[i].copy;
        textBlocks[i] = generateTextBlock(subTitle, copyText)
      }
    }
  }
  const projectInfoWide = [
    <Grid.Column key={'colA'}>
      {textBlocks[0]}
    </Grid.Column>,
    <Grid.Column key={'colB'}>
      {textBlocks[1]}
    </Grid.Column>,
    <Grid.Column key={'colC'}>
      {textBlocks[2]}
    </Grid.Column>
  ]

  const projectInfoNarrow = [
    <Grid.Column key={'colA'} width={16} >
      {textBlocks[0]}
    </Grid.Column>,
    <Grid.Column key={'colB'} width={16}>
      {textBlocks[1]}
    </Grid.Column>,
    <Grid.Column key={'colC'} width={16}>
      {textBlocks[2]}
    </Grid.Column>
  ]


  let nextProjUI = null;
  const nextProjectId = findNextProjectId(idNum)
  if (nextProjectId !== null) {
    nextProjUI = <Link to={`/projects/${nextProjectId}`}>next<Icon name={'chevron right'}/></Link>
  }
  let prevProjUI = null;
  const prevProjectId = findPreviousProjectId(idNum)
  if (prevProjectId !== null) {
    prevProjUI = <Link to={`/projects/${prevProjectId}`} style={{paddingRight:'20px'}}><Icon name={'chevron left'}/>previous</Link>
  }

  // Not used
  // <Link to={'/'} style={{padding: '0 20px 0 20px'}}><Icon name={'chevron up'}/>all projects</Link>

  const projectTitle =
    <div className={'projectTitle'}>
      <h1 style={{display: 'inline'}}>{title}</h1>
      <span style={{float: 'right', fontSize: '1em', textAlign: 'right'}}>
        {prevProjUI}
        {nextProjUI}
      </span>
    </div>

  const projectDetailsNarrow =
    <div>
      {projectTitle}
      <Grid>
        <Grid.Column width={16}>
          {image01}
        </Grid.Column>
        {projectInfoNarrow}
        <Grid.Column width={16}>
          {image02}
        </Grid.Column>
        <Grid.Column width={16}>
          {image03}
        </Grid.Column>
      </Grid>
    </div>

  const projectDetailsWide =
    <div>
      {projectTitle}
      <Grid columns={3}>
        <Grid.Column>
          {image01}
        </Grid.Column>
        <Grid.Column>
          {image02}
        </Grid.Column>
        <Grid.Column>
          {image03}
        </Grid.Column>
        {projectInfoWide}
      </Grid>
    </div>
  return {projectDetailsWide, projectDetailsNarrow}
}

const Project = ({match}) => {

  const {projectDetailsWide, projectDetailsNarrow} = generateContent(match)

  return (
    <div>
      <Responsive as={Container} {...Responsive.onlyComputer}>
        {projectDetailsWide}
      </Responsive>
      <Responsive as={Container} maxWidth={991}>
        {projectDetailsNarrow}
      </Responsive>
    </div>
  )
}

export default Project



// WEBPACK FOOTER //
// ./src/modules/project/Project.js